import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';
import { ExclamationMarkErrorIcon } from 'src/domains/layouts/shared/assets/icons/ExclamationMarkErrorIcon';
import { InputStateType } from './PromoCodeInput';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';

interface InputPropType {
    status: InputStateType;
}

export const ErrorIconWrapper = withConfig(theme => styled(ExclamationMarkErrorIcon, { label: 'ErrorIconWrapper' })`
    margin-left: 15px;
    width: 16px;
    fill: ${theme.star.promoCodeInput.bgColorTertiary};
`);
export const SuccessIconWrapper = withConfig(theme => styled(CheckSingleIcon, { label: 'SuccessIconWrapper' })`
    width: 16px;
    fill: ${theme.star.promoCodeInput.bgColor};
`);

export const ErrorMessage = withConfig(theme => styled('div', { label: 'ErrorMessage' })`
    color: ${theme.star.promoCodeInput.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.xMedium};
    line-height: 1.33;
`);

export const Label = withConfig(theme => styled('div', { label: 'Label' })`
    color: ${theme.star.promoCodeInput.txtColorSecondary};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.42;
    margin-top: -3px;
    cursor: pointer;
`);

export const ActionItemWrapper = styled('div', { label: 'ActionItemWrapper' })`
    margin: 0 11px;
    display: flex;
    justify-content: center;
    align-items: center; 
`;

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    height: 42px;
    width: 100%;
    position: relative;
`;
export const WhiteShadow = styled('span', { label: 'WhiteShadow' })`
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    width: 10px;
    background: linear-gradient(to right, transparent, white);
`;

export const StyledInput = withConfig(theme => styled('input', { label: 'StyledInput' })<InputPropType>`
    color: ${theme.star.promoCodeInput.txtColor};
    width: 100%;
    padding: 12px 0 12px 12px;
    border: none;
    ${({ status }): string => status === 'success' ? `background-color: ${theme.star.promoCodeInput.bgColorSecondary}; color: ${theme.star.promoCodeInput.txtColorQuaternary}` : `${theme.star.accountDrawer.bgColor}`};
    &::placeholder {
        color: ${theme.star.promoCodeInput.txtColorQuinary};
        font-size: ${theme.star.fontSize.xRegular};
        font-weight: ${theme.star.fontWeight.regular};
        line-height: 1.42;
    }
`);

export const InnerElementsWrapper = withConfig(theme => styled('div', { label: 'InnerElementsWrapper' })<InputPropType>`
    display: flex;
    align-items: center;
    background-color: ${theme.star.accountDrawer.bgColor};

    border: 1px solid ${({ status }): string => status === 'success' ? `${theme.star.promoCodeInput.borderColorPrimary}`: status === 'error' ? `${theme.star.promoCodeInput.borderColorSecondary}` : 'transparent'};

    ${({ status }): string => status === 'success' ? `background-color: ${theme.star.promoCodeInput.bgColorSecondary}; color: ${theme.star.promoCodeInput.txtColorQuaternary}` : ''};

    &:focus-within {
        border: 1px solid ${({ status }): string => status === 'error' ? `${theme.star.promoCodeInput.borderColorSecondary}` : `${theme.star.promoCodeInput.borderColorTertiary}`};
    }
`);

export const LoaderWrapper = withConfig(theme => styled(Loader, { label: 'LoaderWrapper' })`
    color: ${theme.star.promoCodeInput.txtColorSecondary};
`);
